import { RESET_FORM } from '../actionTypes';
import { loadAndWindModalActons } from '../reducer';

export default () => loadAndWindModalActons[RESET_FORM]();
